import React from "react";

interface PortfolioTotalsProps {
  profit: number;
  expenses: number;
}

const format = (n: number) => {
  return n.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
};

const PortfolioTotals: React.FC<PortfolioTotalsProps> = ({ profit, expenses }) => (
  <div className="flex items-center gap-6 justify-center my-3 mb-5">
    <div className="flex flex-col items-center bg-card rounded-lg px-4 py-2 shadow-md min-w-[110px]">
      <span className="text-xs font-medium text-muted-foreground">Total Profit</span>
      <span className="font-bold text-2xl text-primary mt-1">{format(profit)}</span>
    </div>
    <div className="flex flex-col items-center bg-card rounded-lg px-4 py-2 shadow-md min-w-[110px]">
      <span className="text-xs font-medium text-muted-foreground">Total Expenses</span>
      <span className="font-bold text-2xl text-destructive mt-1">{format(expenses)}</span>
    </div>
  </div>
);

export default PortfolioTotals;
